import { createStore } from 'satcheljs';
import OwaCalendarLayoutStore from './schema/owaCalendarLayoutStore';

const owaCalendarLayoutStore: OwaCalendarLayoutStore = {
    hasUserSetAgendaPane: false,
    hasUserSetLeftNav: false,
    isAgendaPaneShown: false,
    isLeftNavShown: false,
};

export const getStore = createStore<OwaCalendarLayoutStore>(
    'OwaCalendarLayout',
    owaCalendarLayoutStore
);
